import React from "react";
import { Button, Header, Icon, Modal } from "semantic-ui-react";

function SummaryModal({ data, open, setOpen, onSuccess, dataForOnSuccess, t }) {
  const { campaigns, siteVersion } = dataForOnSuccess;
  return (
    <div>
      {open && (
        <Modal open={open} size="small">
          {data && data.length > 0 && (
            <>
              <Header icon>{t("export_campaigns_modal_header")}</Header>
              <Modal.Content className="process-modal">
                {data.map((summary) => {
                  return (
                    <div key={summary.deliveryCode}>
                      <h4 style={{ fontWeight: "bold", marginBottom: ".5rem" }}>{summary.title}</h4>
                    </div>
                  );
                })}
              </Modal.Content>
            </>
          )}
          <Modal.Actions>
            <Button color="red" onClick={() => setOpen(false)}>
              <Icon name="remove" /> {t("cancel")}
            </Button>
            <Button
              data-test="confirmation_modal_confirm"
              color="green"
              disabled={data.length === 0}
              onClick={() => {
                setOpen(false);
                onSuccess({ campaigns: campaigns, siteVersion: siteVersion });
              }}
            >
              <Icon name="checkmark" /> {t("export_campaigns")}
            </Button>
          </Modal.Actions>
        </Modal>
      )}
    </div>
  );
}

export default SummaryModal;
